import { render, staticRenderFns } from "./MenuGroupFrame.vue?vue&type=template&id=489077b0&"
import script from "./MenuGroupFrame.vue?vue&type=script&lang=js&"
export * from "./MenuGroupFrame.vue?vue&type=script&lang=js&"
import style0 from "./MenuGroupFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports